export const commercialServicePages = [
  {
    path: '/ecommerce-website-redesign',
    slug: 'ecommerce-website-redesign',
    breadcrumbName: 'Ecommerce Website Redesign',
    metaTitle: 'Ecommerce Website Redesign Services',
    metaDescription:
      'Redesign an established Shopify or BigCommerce store for easier shopping and stronger merchandising. Improve mobile usability and daily management.',
    serviceName: 'Ecommerce Website Redesign Services',
    serviceType: 'Ecommerce Website Redesign',
    eyebrow: 'Ecommerce Design and Development',
    heroBefore: 'Ecommerce ',
    heroHighlight: 'Website Redesign',
    heroAfter: '',
    heroDescription:
      'We redesign established Shopify and BigCommerce stores to make shopping simpler for your customers and everyday updates easier for your team.',
    intro:
      'Ventura redesigns established Shopify and BigCommerce stores that have become difficult to shop or manage. We preserve the parts that still work and improve the parts that create customer friction or slow the business down.',
    audience:
      'established ecommerce businesses with an existing store, measurable traffic, operational history, and a clear reason to improve the customer or administrative experience.',
    problemsHeading: 'We solve the problems holding your storefront back',
    problemsIntro:
      'A redesign makes sense when the problem is broader than a new banner or isolated theme edit, but a platform migration is not automatically the right answer.',
    problems: [
      {
        title: 'Are your customers struggling to find and evaluate products?',
        description:
          'Customers have trouble navigating the catalog, comparing products, or completing purchases. These problems often become more pronounced on mobile devices.',
      },
      {
        title: 'Does your storefront no longer reflect your brand?',
        description:
          'Years of incremental changes can leave the site with inconsistent layouts and outdated visual patterns. The homepage and merchandising may no longer support the products the business needs to promote.',
      },
      {
        title: 'Is your team struggling to manage the site efficiently?',
        description:
          'Rigid templates and app conflicts make routine updates unnecessarily difficult. Unclear content structures also force staff to repeat work or rely on a developer for simple changes.',
      },
    ],
    deliverablesHeading: 'What our ecommerce redesign service includes',
    deliverablesIntro:
      'The exact templates and features depend on the store. A typical redesign connects customer experience decisions with merchandising, development, and launch planning.',
    deliverables: [
      {
        title: 'Store design and usability review',
        description:
          'We review the templates and customer paths that matter most.',
      },
      {
        title: 'Homepage and navigation redesign',
        description:
          'We make it easier for customers to reach important products and categories.',
      },
      {
        title: 'Product and category improvements',
        description: 'We improve how customers find and evaluate products.',
      },
      {
        title: 'Cart and checkout improvements',
        description:
          'We clarify calls to action and reduce avoidable cart friction.',
      },
      {
        title: 'Responsive theme implementation',
        description:
          'We build the approved designs into your Shopify or BigCommerce theme and make sure they work on mobile and desktop.',
      },
      {
        title: 'Quality assurance and launch support',
        description:
          'We test the priority templates and purchasing paths on representative devices.',
      },
    ],
    platforms: [
      'Shopify',
      'Shopify Plus',
      'BigCommerce',
      'GA4',
      'Google Tag Manager',
      'Search Console',
      'Klaviyo',
      'Reviews and subscription apps',
    ],
    credentials: [
      'Shopify Partner with experience building and maintaining Shopify storefronts.',
      'BigCommerce Partner and BigCommerce-certified development experience.',
      'More than 25 years of ecommerce website work and over 1,000 sites launched.',
    ],
    processIntro:
      'We separate diagnosis from design and implementation. This keeps the project focused on observed problems instead of subjective preferences.',
    process: [
      {
        title: 'We review your current store',
        description:
          'We review how customers browse and buy from your store, using your analytics to help identify problems. We also learn what your team finds difficult to update and what the redesign needs to achieve.',
      },
      {
        title: 'We agree on a redesign plan with you',
        description:
          'We work with you to decide which pages and features need to change. Before design begins, we agree on the work included, what content your team will provide, and how you will review the designs.',
      },
      {
        title: 'We design and build your updated store',
        description:
          'We design and build the agreed improvements. You review the work at agreed stages so we can resolve feedback before moving forward.',
      },
      {
        title: 'We test and launch your redesign',
        description:
          'We test your updated store on mobile and desktop, check that customers can place orders, and verify tracking. We coordinate the launch with your team and check the store again afterward.',
      },
    ],
    faqs: [
      {
        question:
          'Can you redesign our ecommerce site without changing platforms?',
        answer:
          'Yes. Most redesign projects improve the existing Shopify or BigCommerce store. We recommend a migration only when the current platform creates material operational or technical limits.',
      },
      {
        question: 'Do we need to redesign every page at once?',
        answer:
          'No. The project can focus on the templates and customer journeys that matter most. Common priorities include the homepage and navigation. Product pages and category pages may also need attention. The cart and key landing pages can remain in scope without requiring a sitewide redesign.',
      },
      {
        question: 'Will you use our existing theme or build a new one?',
        answer:
          'That depends on the quality and flexibility of the current theme. We check whether your current theme can support the changes you need before recommending a replacement or more extensive rebuild.',
      },
      {
        question: 'Can you preserve our SEO during the redesign?',
        answer:
          'We preserve valuable URLs and metadata where practical, review redirects and canonicals, and check crawlable content and tracking before launch. A redesign still requires careful monitoring after release.',
      },
      {
        question: 'How do you measure whether the redesign worked?',
        answer:
          'We agree on the relevant indicators before launch. We may track conversion rate or revenue per visitor to see whether the updated store performs better. Customer behavior and internal efficiency may also be evaluated when they are central to the redesign.',
      },
    ],
  },
  {
    path: '/b2b-ecommerce-agency',
    slug: 'b2b-ecommerce-agency',
    breadcrumbName: 'B2B Ecommerce Agency',
    metaTitle: 'B2B Ecommerce Agency for Complex Catalogs',
    metaDescription:
      'B2B ecommerce strategy and implementation for manufacturers, distributors, wholesalers, and hybrid stores using Shopify or BigCommerce.',
    serviceName: 'B2B Ecommerce Agency Services',
    serviceType: 'B2B Ecommerce Design, Development, and Consulting',
    eyebrow: 'B2B Ecommerce Strategy and Implementation',
    heroBefore: '',
    heroHighlight: 'B2B',
    heroAfter: ' Ecommerce Agency',
    heroDescription:
      'We build B2B online stores for manufacturers and distributors whose buyers need more than a standard retail checkout.',
    intro:
      'Ventura helps B2B ecommerce businesses serve wholesale buyers, dealers, purchasing teams, and direct customers through one clear digital experience. We begin with the way the business actually sells and fulfills orders.',
    audience:
      'manufacturers and distributors with complex sales processes. This also includes wholesalers and dealer networks as well as businesses serving both B2B and direct customers.',
    problemsHeading: 'We make complex B2B buying easier',
    problemsIntro:
      'The right approach starts with how customers buy and how products are configured. The ecommerce platform must also support the business processes behind each order.',
    problems: [
      {
        title:
          'Do your wholesale and retail customers need different ways to order?',
        description:
          'Wholesale accounts and direct customers do not always follow the same path. They may need different information, pricing, ordering rules, or ways to contact the business.',
      },
      {
        title: 'Are your products difficult to explain or order online?',
        description:
          'Large or technical catalogs can be difficult to browse. Product specifications, compatibility rules, and shipping constraints must be presented in a way buyers can understand.',
      },
      {
        title:
          'Is your website disconnected from your internal ordering process?',
        description:
          'Manual handoffs and disconnected systems create delays for customers and staff. The website should support the internal process instead of creating another layer of work.',
      },
      {
        title: 'Your internal team cannot own every ecommerce task',
        description:
          'We support manufacturers and distributors with small internal teams by managing recurring catalog and storefront work, keeping priorities organized, and coordinating the development and marketing work included in your program.',
      },
    ],
    deliverablesHeading: 'What our B2B ecommerce services include',
    deliverablesIntro:
      'We define the customer journeys first. Then we determine which platform features, integrations, content, and custom development are required.',
    deliverables: [
      {
        title: 'B2B discovery and requirements',
        description:
          'We identify your customer groups and document how pricing and ordering should work for each.',
      },
      {
        title: 'Catalog and product discovery',
        description: 'We make large or specialized catalogs easier to use.',
      },
      {
        title: 'Wholesale and dealer experiences',
        description:
          'We plan how wholesale customers and dealers will access pricing and place orders.',
      },
      {
        title: 'Quote and contact workflows',
        description:
          'We create a clear next step when a product cannot follow a standard checkout.',
      },
      {
        title: 'Platform and app configuration',
        description:
          'We configure native B2B features and selected apps before recommending custom work that increases long-term maintenance.',
      },
      {
        title: 'Integration and launch coordination',
        description:
          'We coordinate the technical dependencies and data required for launch.',
      },
    ],
    platforms: [
      'Shopify Plus B2B',
      'Shopify',
      'BigCommerce B2B',
      'BigCommerce Enterprise',
      'ERP and PIM integrations',
      'Dealer applications',
      'Quote workflows',
      'Product feeds and catalogs',
    ],
    credentials: [
      'Shopify Partner experience with custom themes, apps, catalogs, and operational workflows.',
      'BigCommerce Partner and certified development experience for complex ecommerce implementations.',
      'Long-term work with manufacturers, distributors, industrial products, and specialty catalogs.',
    ],
    processIntro:
      'B2B projects fail when the technology is selected before the buying and operating requirements are understood. We make those requirements visible first.',
    process: [
      {
        title: 'We learn how your customers order',
        description:
          'We identify the buyer groups and order paths the site must support. We also document internal ownership, catalog requirements, and connected systems.',
      },
      {
        title: 'We recommend the right setup',
        description:
          'We compare native platform capabilities with appropriate apps and custom development. Integration risks and phased alternatives are included in the decision.',
      },
      {
        title: 'We build your B2B storefront',
        description:
          'We implement the approved storefront and its audience-specific paths. The build also includes the content, forms, catalog structures, and integrations defined in scope.',
      },
      {
        title: 'We test real orders with your team',
        description:
          'We work with your team to test how different customer accounts place orders before launch. Test orders confirm pricing and approvals. They also show whether shipping rules and internal handoffs work correctly.',
      },
    ],
    faqs: [
      {
        question:
          'Can one ecommerce site support both B2B and direct-to-consumer buyers?',
        answer:
          'Yes. The two audiences must be clearly defined. Their pricing and account rules may differ. Their content and order paths may differ as well. The best architecture depends on how much the two experiences overlap.',
      },
      {
        question:
          'Do we need Shopify Plus or BigCommerce Enterprise for B2B ecommerce?',
        answer:
          'Not always. We first compare the required native features with available app options. We then consider any custom work and its operating cost. Long-term constraints determine whether an enterprise plan is justified.',
      },
      {
        question: 'Can you connect our ecommerce store to an ERP or PIM?',
        answer:
          'We can plan and coordinate integrations, and we implement selected connections where the APIs, data ownership, and scope are clear. Complex middleware or ERP development may require a specialized integration partner.',
      },
      {
        question:
          'Can customers request quotes instead of checking out online?',
        answer:
          'Yes. We can create quote, consultation, dealer, or contact workflows for products and orders that should not follow a standard checkout path.',
      },
      {
        question: 'How do you handle a very large or technical catalog?',
        answer:
          'We plan the catalog structure and buyer navigation as one system. Specifications and media support that structure. Product relationships and data ownership matter as well. Catalog planning is a core project requirement rather than a final content task.',
      },
    ],
  },
  {
    path: '/shopify-theme-customization',
    slug: 'shopify-theme-customization',
    breadcrumbName: 'Shopify Theme Customization',
    metaTitle: 'Shopify Theme Customization Services',
    metaDescription:
      'Customize an existing Shopify theme with maintainable Liquid development, reusable sections, template updates, and responsive storefront improvements.',
    serviceName: 'Shopify Theme Customization Services',
    serviceType: 'Shopify Theme Customization and Liquid Development',
    eyebrow: 'Shopify Design and Development',
    heroBefore: '',
    heroHighlight: 'Shopify',
    heroAfter: ' Theme Customization',
    heroDescription:
      'We customize existing Shopify themes with maintainable Liquid development, reusable sections, and responsive improvements.',
    intro:
      'Ventura customizes existing Shopify themes when the foundation still works but the storefront needs better layouts or functionality. We improve the theme without forcing a complete redesign.',
    audience:
      'Shopify and Shopify Plus merchants with a stable store that needs targeted theme development, new reusable sections, template changes, or technically responsible fixes.',
    problemsHeading: 'We make your Shopify theme work for your business',
    problemsIntro:
      'Theme customization is the right fit when the store needs more than settings changes but does not need a complete redesign or platform migration.',
    problems: [
      {
        title:
          'Is your theme unable to support the pages and promotions you need?',
        description:
          'Existing sections and templates may be too rigid for the content the team needs to publish. This often limits landing pages, product merchandising, and promotional updates.',
      },
      {
        title: 'Have apps and custom code created conflicts in your store?',
        description:
          'Old integrations and undocumented theme changes can conflict with current apps. The result may be broken layouts, duplicated scripts, or inconsistent storefront behavior.',
      },
      {
        title: 'Are mobile usability problems making shopping harder?',
        description:
          'Small mobile problems can create meaningful buying friction. We refine the content order and product information first. Buttons, product options, and the cart should be easy to use on smaller screens.',
      },
    ],
    deliverablesHeading:
      'What our Shopify theme customization service includes',
    deliverablesIntro:
      'We work within Shopify theme architecture and use native capabilities before adding code that the store must carry forward.',
    deliverables: [
      {
        title: 'Theme and code review',
        description: 'We inspect the active theme and any relevant copies.',
      },
      {
        title: 'Liquid and theme development',
        description:
          'We update the Liquid and JSON templates required for the approved customization.',
      },
      {
        title: 'Reusable custom sections',
        description:
          'We build editor-friendly sections and blocks when store staff need repeatable layouts rather than one locked page.',
      },
      {
        title: 'Product and collection templates',
        description:
          'We improve how product and collection templates present information.',
      },
      {
        title: 'App integration and cleanup',
        description:
          'We coordinate app integrations and remove obsolete theme code where safe.',
      },
      {
        title: 'Responsive QA and controlled release',
        description:
          'We test the customized theme across representative devices and purchasing paths before publishing it to the live store.',
      },
    ],
    platforms: [
      'Shopify',
      'Shopify Plus',
      'Liquid',
      'Online Store 2.0',
      'JSON templates',
      'Metafields',
      'Shopify Search and Discovery',
      'Shopify apps',
    ],
    credentials: [
      'Shopify Partner with hands-on theme, catalog, app, and launch experience.',
      'Experience supporting stores after launch through hourly and ongoing development relationships.',
      'More than 25 years of ecommerce design and development work across established platforms.',
    ],
    processIntro:
      'We protect the live storefront by diagnosing dependencies, working in a controlled theme copy, and testing the requested behavior before release.',
    process: [
      {
        title: 'We review the changes you need',
        description:
          'We review the desired behavior and the templates it affects. We identify any app or data dependency. We review previous theme changes and agree with you on what the finished update should do.',
      },
      {
        title: 'We recommend how to make them',
        description:
          'We determine whether the request is best handled through settings, native Shopify features, an app, or custom theme development.',
      },
      {
        title: 'We build the changes in a theme copy',
        description:
          'We implement and review the customization away from the live customer experience whenever the store setup allows it.',
      },
      {
        title: 'We test and publish your approved changes',
        description:
          'We verify representative devices, templates, app behavior, and purchase paths before coordinating publication.',
      },
    ],
    faqs: [
      {
        question: 'Can you customize the Shopify theme we already use?',
        answer:
          'Yes. We begin by reviewing the current theme and its dependencies. If your current theme can support the changes reliably, we can improve it without forcing a replacement.',
      },
      {
        question:
          'Do you work with Shopify Liquid and Online Store 2.0 sections?',
        answer:
          'Yes. We work with Liquid and JSON templates. We build reusable sections and blocks. Metafields can supply structured content. CSS and JavaScript support the approved behavior. We also coordinate app integrations.',
      },
      {
        question: 'Will custom work prevent us from updating the theme later?',
        answer:
          'Any customization can affect future updates. We minimize unnecessary changes and document material work, but major vendor theme updates may still require review and reimplementation.',
      },
      {
        question: 'Can you fix a customization another developer started?',
        answer:
          'Often, yes. We first inspect the code and theme history. We also identify app dependencies and document the current behavior. Investigation time may be required before the final repair scope is known.',
      },
      {
        question:
          'Do you offer ongoing Shopify support after the customization?',
        answer:
          'Yes. Stores can continue through hourly blocks or an ongoing support relationship for theme updates, app troubleshooting, merchandising, and future improvements.',
      },
    ],
  },
  {
    path: '/woocommerce-to-shopify-migration',
    slug: 'woocommerce-to-shopify-migration',
    breadcrumbName: 'WooCommerce to Shopify Migration',
    metaTitle: 'WooCommerce to Shopify Migration Services',
    metaDescription:
      'Move a WooCommerce store to Shopify with documented data mapping and storefront setup. Protect SEO through redirects and launch testing.',
    serviceName: 'WooCommerce to Shopify Migration Services',
    serviceType: 'WooCommerce and WordPress to Shopify Migration',
    eyebrow: 'Ecommerce Platform Migration',
    heroBefore: 'WooCommerce to ',
    heroHighlight: 'Shopify Migration',
    heroAfter: '',
    heroDescription:
      'We move WooCommerce stores to Shopify through a controlled migration that protects critical store data, content, and search visibility.',
    intro:
      'Ventura migrates WooCommerce and WordPress stores to Shopify through a documented process. We plan how store data and content will move, build the Shopify storefront, test the result, and coordinate launch.',
    audience:
      'WooCommerce merchants who want Shopify’s managed ecommerce foundation and need more than an automated product import.',
    problemsHeading: 'We solve the challenges of moving WooCommerce to Shopify',
    problemsIntro:
      'The visible storefront is only one part of the move. The migration must account for data quality and platform differences. Established URLs need protection. Business operations and customer expectations must also carry into the new store.',
    problems: [
      {
        title: 'Does your WooCommerce data need restructuring for Shopify?',
        description:
          'WooCommerce and Shopify organize store data differently. Product attributes and variations rarely map perfectly. Custom fields and plugin data may need a new destination. Complex options often require transformation rather than direct copying.',
      },
      {
        title:
          'Are you worried about losing important content and SEO signals?',
        description:
          'Important products and content need an explicit destination in Shopify. Established URLs also need a redirect plan so customers and search engines can find the replacement pages.',
      },
      {
        title:
          'Are you unsure how to keep your store operational through launch?',
        description:
          'Before launch, we place test orders to check that your Shopify store is ready to sell. Payment and shipping behavior must be validated. Tax rules and notifications must also work. Analytics and customer access need testing. Critical apps must be ready for launch.',
      },
    ],
    deliverablesHeading:
      'What our WooCommerce to Shopify migration service includes',
    deliverablesIntro:
      'The exact import set depends on source quality and agreed scope. We inventory the source before committing to what will transfer and how.',
    deliverables: [
      {
        title: 'Review of your WooCommerce store',
        description:
          'We inspect the WooCommerce catalog and WordPress content before defining the migration.',
      },
      {
        title: 'Product and variant migration',
        description:
          'We transform products and variations into a Shopify-compatible structure.',
      },
      {
        title: 'Customer and content migration',
        description:
          'We move the agreed customer profiles and website content where both systems support it.',
      },
      {
        title: 'Theme and storefront setup',
        description:
          'We configure the Shopify theme and core storefront templates for launch.',
      },
      {
        title: 'Redirect and SEO protection',
        description:
          'We map valuable source URLs to their Shopify destinations and preserve useful metadata where practical.',
      },
      {
        title: 'Launch and migration checks',
        description:
          'We test representative products and orders before coordinating the domain cutover.',
      },
    ],
    platforms: [
      'WooCommerce',
      'WordPress',
      'Shopify',
      'Shopify Plus',
      'Judge.me',
      'Klaviyo',
      'GA4',
      'Google Search Console',
    ],
    credentials: [
      'Shopify Partner with hands-on catalog, theme, app, domain, and launch experience.',
      'WooCommerce experience across products, customers, content, plugins, and WordPress administration.',
      'Migration procedures that include reconciliation and redirects instead of relying only on an automated transfer.',
    ],
    processIntro:
      'We keep the source store available as a reference, define transformation rules before import, and reconcile the Shopify result before launch.',
    process: [
      {
        title: 'We review your WooCommerce store',
        description:
          'We inventory the available data and establish source counts. Product structures receive a separate review from website content. Media and URLs are documented. We also record plugin dependencies and operational requirements before mapping begins.',
      },
      {
        title: 'We plan how your data will move',
        description:
          'We document where your products, customer information, and content will go in Shopify. We also identify anything that needs a different setup or cannot be transferred.',
      },
      {
        title: 'We build and check your Shopify store',
        description:
          'We configure the Shopify store and import the agreed data. We build your storefront and compare the imported data with your WooCommerce store to find and correct problems.',
      },
      {
        title: 'We launch your store and check the migration',
        description:
          'We complete the final data steps and test orders and tracking. Then we coordinate the domain and redirects before reviewing the store after launch.',
      },
    ],
    faqs: [
      {
        question:
          'Can you migrate WooCommerce store data and content to Shopify?',
        answer:
          'Yes, when the source data is available and the destination supports it. We inventory each data type and document the migration rules before import.',
      },
      {
        question: 'Can you migrate product reviews?',
        answer:
          'We review your current review platform and the Shopify review app before migration. When the data can be exported and matched to products, we migrate the supported review fields, check sample records, and document anything that cannot transfer.',
      },
      {
        question: 'Do you migrate historical WooCommerce orders?',
        answer:
          'No, historical orders are not included in Ventura’s standard WooCommerce-to-Shopify migration scope. We can discuss archival or reference options separately.',
      },
      {
        question: 'Will customers keep their passwords after the migration?',
        answer:
          'WooCommerce passwords cannot normally be transferred into Shopify as usable passwords. Customer profiles can be imported, and customers must activate access through Shopify.',
      },
      {
        question: 'How do you protect SEO when URLs change?',
        answer:
          'We inventory valuable source URLs and map each one to a destination. Redirects are implemented before launch. Useful metadata is preserved where practical. After launch, we review Search Console and crawl behavior.',
      },
      {
        question: 'Can every WooCommerce plugin be recreated in Shopify?',
        answer:
          'No. We document the business purpose of important plugins and determine whether Shopify supports it natively, through an app, through custom work, or through a changed process.',
      },
    ],
  },
  {
    path: '/ecommerce-data-migration-services',
    slug: 'ecommerce-data-migration-services',
    breadcrumbName: 'Ecommerce Data Migration Services',
    metaTitle: 'Ecommerce Data Migration Services',
    metaDescription:
      'Move complex ecommerce data through documented mapping and controlled transformation. Validate imports through reconciliation and exception reporting.',
    serviceName: 'Ecommerce Data Migration Services',
    serviceType: 'Ecommerce Catalog and Platform Data Migration',
    eyebrow: 'Ecommerce Data Migration',
    heroBefore: 'Ecommerce ',
    heroHighlight: 'Data Migration',
    heroAfter: ' Services',
    heroAllBlack: true,
    heroDescription:
      'We prepare and move your ecommerce data to its new platform, then check the results against the original records.',
    intro:
      'Ventura prepares and migrates ecommerce data for platform moves and store rebuilds. We also support catalog cleanup and large updates. Our work spans Shopify and BigCommerce as well as WooCommerce and connected data sources.',
    audience:
      'ecommerce teams moving platforms or combining stores. This service also fits catalog cleanup projects and product structures that do not work with a standard import.',
    problemsHeading: 'We turn complex ecommerce data into a reliable migration',
    problemsIntro:
      'Reliable migration work begins with clear field definitions and transformation rules. Source counts, known exceptions, and data ownership must also be established before importing anything.',
    problems: [
      {
        title: 'Do your product structures differ between systems?',
        description:
          'The same product can be structured very differently from one platform to another. Options and categories must follow the destination rules. The same is true for custom fields and inventory. Images and pricing require explicit mappings as well.',
      },
      {
        title: 'Does your source catalog contain years of inconsistent data?',
        description:
          'Years of catalog changes often leave duplicate values and inconsistent records. Missing images, malformed text, inactive products, and undocumented fields increase import risk.',
      },
      {
        title:
          'Are you unsure whether your import transferred everything correctly?',
        description:
          'Matching record counts do not prove that the destination is correct. Product relationships and images still require validation. So do website content and redirects. The customer-facing result must also be checked.',
      },
    ],
    deliverablesHeading: 'What our ecommerce data migration service includes',
    deliverablesIntro:
      'We define what will move, how it will change, what will not move, and how the destination will be checked before the migration is treated as complete.',
    deliverables: [
      {
        title: 'Source-data inventory',
        description: 'We identify the available exports and APIs.',
      },
      {
        title: 'Field and structure mapping',
        description:
          'We map each approved record type to its destination structure.',
      },
      {
        title: 'Cleanup and transformation',
        description:
          'We clean up the agreed data and format it for the new platform.',
      },
      {
        title: 'Data import',
        description:
          'We choose the import method according to the volume and complexity of the approved data.',
      },
      {
        title: 'Image and content migration',
        description: 'We move and validate the agreed media and content.',
      },
      {
        title: 'Migration checks and a report of any gaps',
        description:
          'We reconcile source data with the destination and document exceptions.',
      },
    ],
    platforms: [
      'Shopify',
      'Shopify Plus',
      'BigCommerce',
      'WooCommerce',
      'CSV',
      'Platform APIs',
      'Judge.me',
      'Product feeds',
    ],
    credentials: [
      'Hands-on migration experience across products, variants, images, customers, pages, blogs, reviews, and redirects.',
      'Shopify Partner and BigCommerce Partner experience on both sides of ecommerce data projects.',
      'Purpose-built migration processes that preserve a read-only source reference and validate the destination.',
    ],
    processIntro:
      'Data migration is treated as a controlled transformation with written rules, repeatable imports, and measurable reconciliation rather than a one-click transfer.',
    process: [
      {
        title: 'We review your existing data',
        description:
          'We gather the available data and establish source counts. Then we inspect its structure, identify quality issues, and confirm the source of truth.',
      },
      {
        title: 'We agree on data cleanup rules with you',
        description:
          'We flag unclear records and recommend how to handle them. You approve the decisions before we change the data. Those decisions govern inactive records and duplicate customers. They also determine how categories and options should be handled. Custom values follow the same approved rules.',
      },
      {
        title: 'We prepare and import your data',
        description:
          'We prepare destination-ready records and run controlled imports. Technical errors discovered during execution are corrected before reconciliation.',
      },
      {
        title: 'We check the results and report any gaps',
        description:
          'We compare the source with the destination and review representative records. The client receives a clear account of any remaining exceptions.',
      },
    ],
    faqs: [
      {
        question: 'What ecommerce data can you migrate?',
        answer:
          'The available data depends on the source and destination. Common migrations include catalog records and images. Customer profiles and website content may also move. Reviews and custom fields require compatible destinations. Redirect mappings protect established URLs.',
      },
      {
        question: 'Can you clean the catalog while moving it?',
        answer:
          'Yes, when cleanup rules are defined. We can normalize fields and resolve agreed duplicates. We can also repair handles and organize categories. Records that require a business decision are identified for the client.',
      },
      {
        question: 'How do you verify that the migration is complete?',
        answer:
          'We compare source and destination counts. Then we review representative records and validate key relationships. Images receive a separate check. Any exception that cannot be resolved automatically is documented.',
      },
      {
        question: 'Can you migrate complex product options?',
        answer:
          'Often, but platform limits matter. We document which options should become true variants or modifiers. Other values may require line-item properties or metafields. Some products need an app or a changed structure.',
      },
      {
        question: 'Will you keep the source store unchanged during migration?',
        answer:
          'Our standard approach is to treat the source as read-only whenever practical. That preserves a stable reference for mappings, validation, and exception review.',
      },
    ],
  },
  {
    path: '/shopify-seo',
    slug: 'shopify-seo',
    breadcrumbName: 'Shopify SEO Services',
    metaTitle: 'Shopify SEO Services and Agency Support',
    metaDescription:
      'Improve Shopify visibility through technical SEO and stronger catalog pages. Connect useful content with internal links and Search Console reporting.',
    serviceName: 'Shopify SEO Services',
    serviceType: 'Shopify Search Engine Optimization',
    eyebrow: 'Shopify Organic Search Growth',
    heroBefore: '',
    heroHighlight: 'Shopify',
    heroAfter: ' SEO Services',
    heroDescription:
      'We improve Shopify search visibility by fixing technical issues and improving the product and collection pages your customers find through search.',
    intro:
      'Ventura provides Shopify SEO for brands that need more than metadata edits. We improve the technical foundation and important commercial pages, then use Search Console and analytics to guide ongoing priorities.',
    audience:
      'Shopify and Shopify Plus merchants that want qualified organic visibility and need an agency that understands both search strategy and the platform implementation behind it.',
    problemsHeading: 'We address the SEO issues limiting your Shopify store',
    problemsIntro:
      'Shopify can support strong organic performance, but the platform does not make every store search-ready by default. Themes and apps can affect technical output, while weak catalog architecture and thin content limit useful pages.',
    problems: [
      {
        title:
          'Are your products and collections missing the terms buyers search for?',
        description:
          'Products and collections may use language that does not match buyer searches. Limited context and weak internal links also make important pages harder for customers and search engines to understand.',
      },
      {
        title:
          'Are search engines receiving conflicting signals from your store?',
        description:
          'Theme and app output can send inconsistent indexing signals. Problems with canonicals, redirects, structured data, or duplicate paths may dilute otherwise valuable content.',
      },
      {
        title: 'Is your team unsure which SEO work to tackle next?',
        description:
          'Content and technical work often move forward without a shared priority. Search queries, page performance, conversions, and competitors should determine what the team improves next.',
      },
    ],
    deliverablesHeading: 'What our Shopify SEO services include',
    deliverablesIntro:
      'We work across the technical foundation, catalog, and content instead of limiting SEO to metadata edits. Performance data connects those improvements to measurable priorities.',
    deliverables: [
      {
        title: 'Technical Shopify SEO',
        description:
          'We review whether search engines can crawl and index the right Shopify pages.',
      },
      {
        title: 'Collection optimization',
        description:
          'We improve important collection pages around the products and terms your customers search for.',
      },
      {
        title: 'Product-page optimization',
        description:
          'We strengthen product information so customers and search engines can understand what is being sold.',
      },
      {
        title: 'Keyword and content planning',
        description:
          'We identify commercial pages and buyer questions that deserve better content.',
      },
      {
        title: 'Internal linking and architecture',
        description:
          'We add relevant links between product pages, collections, and helpful articles.',
      },
      {
        title: 'Reporting and iteration',
        description:
          'We compare Search Console and analytics performance with completed work.',
      },
    ],
    platforms: [
      'Shopify',
      'Shopify Plus',
      'Google Search Console',
      'GA4',
      'Google Tag Manager',
      'Semrush',
      'Shopify Search and Discovery',
      'Structured data',
    ],
    credentials: [
      'Shopify Partner with direct access to theme, catalog, app, and storefront implementation work.',
      'Semrush Agency Partner and hands-on Google Search Console reporting experience.',
      'SEO support that can continue through migrations, redesigns, maintenance, and conversion work.',
    ],
    processIntro:
      'Search work is prioritized from evidence, implemented in the store, documented, and reviewed against current performance instead of delivered as a static recommendation list.',
    process: [
      {
        title: 'We review your current search performance',
        description:
          'We review Search Console and analytics alongside the current catalog and templates. Apps, content, competitors, and conversion paths provide the context needed to establish a useful baseline.',
      },
      {
        title: 'We identify the most useful improvements',
        description:
          'We organize the opportunities by business relevance and likely impact. Effort, dependencies, and required access help determine the sequence.',
      },
      {
        title: 'We make the agreed changes',
        description:
          'We complete the agreed Shopify improvements in the store. The work may involve content or technical fixes. Structured data and redirects can be included. Internal links often connect those changes.',
      },
      {
        title: 'We measure results and plan the next steps',
        description:
          'We review how important queries and pages are performing. Clicks, conversions, indexing, and completed work inform the next practical priorities.',
      },
    ],
    faqs: [
      {
        question: 'What is different about Shopify SEO?',
        answer:
          'Shopify SEO must account for theme output and app behavior. Product and collection architecture shape the pages available to rank. Platform URL patterns and structured data affect search interpretation. Navigation and catalog maintenance influence the result over time.',
      },
      {
        question: 'Do you optimize both products and collections?',
        answer:
          'Yes. We first determine which page best answers each customer search. Then we improve its content and metadata. Product organization and internal links reinforce the page purpose. FAQs and structured data are addressed where appropriate.',
      },
      {
        question: 'Can you fix technical SEO issues inside our Shopify theme?',
        answer:
          'Yes, when the issue exists in accessible theme code or settings. We can also correct problems in content or app configuration. Some platform behavior remains controlled by Shopify and must be handled within its limits.',
      },
      {
        question: 'How long does Shopify SEO take to work?',
        answer:
          'The timing depends on your store’s starting point, the competition, and the changes needed. Technical changes can often be validated quickly. Search engines still need time to crawl and evaluate them. Ranking and revenue effects depend on competition and site history. Demand and the work completed also influence the outcome.',
      },
      {
        question: 'Can you protect SEO during a Shopify migration or redesign?',
        answer:
          'Yes. We inventory valuable pages before the change begins. Useful content and metadata are preserved. Redirects receive explicit mappings. We also review canonical and indexing signals. After launch, we test the new store and monitor Search Console.',
      },
    ],
  },
  {
    path: '/bigcommerce-seo',
    slug: 'bigcommerce-seo',
    breadcrumbName: 'BigCommerce SEO Services',
    metaTitle: 'BigCommerce SEO Services and Agency Support',
    metaDescription:
      'Improve BigCommerce visibility through technical SEO and stronger catalog pages. Connect useful content with Stencil implementation and reporting.',
    serviceName: 'BigCommerce SEO Services',
    serviceType: 'BigCommerce Search Engine Optimization',
    eyebrow: 'BigCommerce Organic Search Growth',
    heroBefore: '',
    heroHighlight: 'BigCommerce',
    heroAfter: ' SEO Services',
    heroDescription:
      'We improve your BigCommerce store’s search visibility through technical fixes and product and category content that answers customer searches. Our reporting shows how performance changes over time.',
    intro:
      'Ventura combines BigCommerce platform experience with ecommerce SEO strategy. We improve technical implementation and important catalog pages, then use search data to guide the next priorities.',
    audience:
      'BigCommerce merchants that need SEO support connected to implementation. This includes stores with Stencil themes and large catalogs. It also fits sites that rely on faceted navigation or ongoing development.',
    problemsHeading:
      'We solve the SEO challenges facing your BigCommerce store',
    problemsIntro:
      'The strongest opportunities often cross several parts of the store. Technical implementation must support useful category architecture, reliable product data, and content the team can maintain.',
    problems: [
      {
        title:
          'Do your product and category pages lack the information buyers need?',
        description:
          'Product and category pages may not explain enough to support a buying decision. They also need a clear purpose and useful relationships with other store content.',
      },
      {
        title: 'Is catalog complexity creating technical duplication?',
        description:
          'Catalog features can generate competing or low-value URLs. Product filters can create extra URLs that need to be managed for search engines. Pagination and canonical signals must agree. Theme output should reinforce those decisions.',
      },
      {
        title: 'Are your SEO recommendations disconnected from development?',
        description:
          'An audit has limited value when no one owns implementation. Ventura can connect the recommendations to Stencil changes, catalog updates, redirects, and quality assurance.',
      },
    ],
    deliverablesHeading: 'What our BigCommerce SEO services include',
    deliverablesIntro:
      'We connect search priorities to the platform and theme work required to complete them. Catalog changes and content improvements remain part of the same roadmap. Reporting shows what should happen next.',
    deliverables: [
      {
        title: 'Technical BigCommerce SEO',
        description:
          'We review whether search engines can crawl and index the right BigCommerce pages.',
      },
      {
        title: 'Category-page optimization',
        description:
          'We improve important category pages around the products and terms your customers search for.',
      },
      {
        title: 'Product and catalog optimization',
        description:
          'We improve the product information needed for search and customer understanding.',
      },
      {
        title: 'Content and competitor research',
        description:
          'We identify missing commercial content and unanswered buying questions.',
      },
      {
        title: 'Stencil and implementation support',
        description:
          'We implement the agreed recommendations instead of leaving the client with an audit alone.',
      },
      {
        title: 'Search reporting and roadmap',
        description:
          'We track how important queries and pages perform over time.',
      },
    ],
    platforms: [
      'BigCommerce',
      'BigCommerce Enterprise',
      'Stencil',
      'Google Search Console',
      'GA4',
      'Google Tag Manager',
      'Semrush',
      'Product feeds',
    ],
    credentials: [
      'BigCommerce Partner and BigCommerce-certified development experience.',
      'More than 25 years of ecommerce work across catalog, development, migration, and growth programs.',
      'Semrush Agency Partner with Search Console and analytics reporting experience.',
    ],
    processIntro:
      'We establish the technical and commercial baseline, complete agreed work in the store, and use current data to guide each subsequent priority.',
    process: [
      {
        title: 'We review your BigCommerce SEO',
        description:
          'We review Search Console and analytics alongside the BigCommerce catalog. Templates and Stencil code establish the technical baseline. Apps and crawl behavior reveal dependencies. Content and competitor evidence show where opportunities exist.',
      },
      {
        title: 'We prioritize the improvements',
        description:
          'We prioritize technical fixes and catalog-page improvements by relevance and likely impact. Dependencies and effort determine which changes we should make first.',
      },
      {
        title: 'We make and test the changes',
        description:
          'We complete the approved BigCommerce changes and verify the visible result. We also check the page code and whether search engines can index the updated pages. We also verify links and structured data. Representative templates are tested before the work is closed.',
      },
      {
        title: 'We report results and refine the plan',
        description:
          'We compare query and page performance with the work completed. Conversions and new issues help determine the next priorities.',
      },
    ],
    faqs: [
      {
        question: 'Do you work directly in BigCommerce and Stencil themes?',
        answer:
          'Yes. Ventura has BigCommerce development experience and can implement agreed theme changes. We also work with templates and structured data. Content and navigation can be improved in the platform. Redirect changes remain subject to BigCommerce capabilities.',
      },
      {
        question: 'Can you optimize a large BigCommerce catalog?',
        answer:
          'Yes. We prioritize catalog records according to business value and search opportunity. Categories and products may receive different treatment. Attributes and filters should support discovery. Custom fields and content should improve understanding. We do not treat every record identically.',
      },
      {
        question: 'How do you handle faceted navigation and duplicate URLs?',
        answer:
          'We inspect how filters and parameters currently behave. Category structure and canonical signals provide additional context. We also review internal links and indexing. The resulting changes preserve useful discovery while reducing low-value duplication.',
      },
      {
        question: 'Can you implement the recommendations from the SEO audit?',
        answer:
          'Yes. Implementation can be included in the project or ongoing program. Theme access and app ownership may affect what we can complete. Platform limits and the agreed development scope still apply.',
      },
      {
        question: 'Do you support BigCommerce migrations without losing SEO?',
        answer:
          'We plan redirects and preserve useful content before launch. Metadata is retained where appropriate. We check canonical and crawlability signals in the destination. Search Console is monitored after release. Some temporary fluctuation remains possible during any migration.',
      },
    ],
  },
  {
    path: '/ecommerce-seo-audit',
    slug: 'ecommerce-seo-audit',
    breadcrumbName: 'Ecommerce SEO Audit',
    metaTitle: 'Ecommerce SEO Audit Services',
    metaDescription:
      'Identify the ecommerce SEO issues that matter most through technical review, Search Console evidence, page analysis, and a prioritized implementation plan.',
    serviceName: 'Ecommerce SEO Audit Services',
    serviceType: 'Ecommerce Search Engine Optimization Audit',
    eyebrow: 'Ecommerce SEO Diagnosis and Priorities',
    heroBefore: 'Ecommerce ',
    heroHighlight: 'SEO Audit',
    heroAfter: '',
    heroDescription:
      'We audit ecommerce SEO and deliver a clear plan showing what to fix, why it matters, and which changes to make first.',
    intro:
      'Ventura evaluates how technical implementation and site content affect organic search performance. Search Console evidence and page-level inspection help us explain what should be fixed first and why.',
    audience:
      'ecommerce teams that need an independent search diagnosis before committing to larger work. We audit Shopify and BigCommerce as well as WooCommerce. The findings can guide monthly SEO or a future site project.',
    problemsHeading:
      'We find what is holding your organic search performance back',
    problemsIntro:
      'An audit is useful when organic performance is weak or difficult to explain. The goal is a defensible sequence of work, not a larger collection of warnings.',
    problems: [
      {
        title: 'Is your organic performance weak or declining?',
        description:
          'The business sees fewer clicks or weaker organic revenue but cannot explain the change. Demand or competition may be responsible. Technical issues and content gaps can also reduce visibility. Measurement problems may distort the apparent loss.',
      },
      {
        title: 'Are different tools giving you an overwhelming issue list?',
        description:
          'Automated tools and internal feedback can produce hundreds of warnings. They do not automatically explain which issues affect customers, search visibility, or revenue.',
      },
      {
        title: 'Do you need an SEO baseline before a major site change?',
        description:
          'Major site changes create search risk when the current baseline is unknown. Valuable pages, queries, links, and indexing signals should be inventoried before the change begins.',
      },
    ],
    deliverablesHeading: 'What our ecommerce SEO audit includes',
    deliverablesIntro:
      'The audit is organized around business impact and platform reality, not the raw number of warnings produced by a crawler.',
    deliverables: [
      {
        title: 'Search performance baseline',
        description:
          'We review the queries and pages currently producing search visibility.',
      },
      {
        title: 'Technical SEO review',
        description:
          'We assess whether search engines can crawl and index the intended pages.',
      },
      {
        title: 'Template and catalog review',
        description:
          'We inspect representative commercial and informational templates rather than reviewing URLs in isolation.',
      },
      {
        title: 'Missing or unclear page content',
        description:
          'We identify pages that lack useful commercial information or do not clearly answer the customer’s search.',
      },
      {
        title: 'Prioritized findings',
        description: 'Recommendations are organized by impact and risk.',
      },
      {
        title: 'Review and next-step plan',
        description:
          'We review the findings with the client and answer implementation questions.',
      },
    ],
    platforms: [
      'Shopify',
      'Shopify Plus',
      'BigCommerce',
      'WooCommerce',
      'Google Search Console',
      'GA4',
      'Semrush',
      'Crawl tools',
    ],
    credentials: [
      'Semrush Agency Partner with platform-level implementation experience.',
      'Shopify Partner and BigCommerce Partner experience for interpreting platform-specific findings.',
      'Migration, redesign, maintenance, and analytics experience that helps identify operational dependencies.',
    ],
    processIntro:
      'The audit moves from data access to diagnosis, prioritization, and a working review so the final document can be used by real teams.',
    process: [
      {
        title: 'We learn about your goals and concerns',
        description:
          'We document the business concern and the people involved. Search Console and available analytics establish the performance context. Recent site changes and campaigns may explain the timing. Known technical history helps us test those possibilities.',
      },
      {
        title: 'We investigate your search performance',
        description:
          'We compare crawl data with actual search and analytics performance. Page inspection, source output, recurring templates, and relevant competitors add context.',
      },
      {
        title: 'We rank the issues by importance',
        description:
          'We identify which issues could affect your search performance and which warnings are lower priority. Recommendations are then organized by commercial value, risk, effort, and dependency.',
      },
      {
        title: 'We explain our findings and recommendations',
        description:
          'We explain the findings and answer implementation questions. The review also explains who needs to make each change and what to tackle first.',
      },
    ],
    faqs: [
      {
        question: 'What does an ecommerce SEO audit include?',
        answer:
          'It includes a search-performance baseline and technical SEO review. We also assess representative templates and important catalog pages. Content quality and internal links receive their own review. Structured data is checked where relevant. The final plan identifies migration risks and implementation priorities.',
      },
      {
        question: 'Is this just an automated crawl report?',
        answer:
          'No. Crawl data is only one evidence source. Search Console and analytics show whether an issue affects actual performance. Platform behavior and recurring templates provide technical context. Business priorities and recent changes help us judge urgency. We also inspect the customer-facing pages.',
      },
      {
        question: 'Will you implement the audit recommendations?',
        answer:
          'Implementation can be scoped as a follow-on project, hourly block, or ongoing SEO program. The standalone audit does not automatically include every recommended change.',
      },
      {
        question: 'Can you investigate a recent organic traffic loss?',
        answer:
          'Yes. We compare the timing of search-performance changes with technical and content changes on the site. Tracking, demand, competition, and migration history are also considered when they are relevant to the diagnosis.',
      },
      {
        question: 'What access will you need?',
        answer:
          'Typical access includes Search Console and GA4. We also request the ecommerce platform and any relevant app settings. Background on recent site changes provides essential context. The exact access list depends on the audit scope.',
      },
    ],
  },
  {
    path: '/google-shopping-management',
    slug: 'google-shopping-management',
    breadcrumbName: 'Google Shopping Management',
    metaTitle: 'Google Shopping Management Services',
    metaDescription:
      'Manage Google Shopping and Performance Max with reliable conversion tracking, product-level oversight, clear budgets, and revenue reporting.',
    serviceName: 'Google Shopping Management Services',
    serviceType: 'Google Shopping and Performance Max Management',
    eyebrow: 'Ecommerce Paid Search',
    heroBefore: '',
    heroHighlight: 'Google Shopping',
    heroAfter: ' Management',
    heroDescription:
      'We manage Google Shopping campaigns with clear budgets, reliable conversion tracking, and product-level performance reporting.',
    intro:
      'Ventura manages Google Shopping and ecommerce Performance Max campaigns around business goals and product economics. We connect campaign decisions with Merchant Center health, conversion tracking, landing pages, and return on ad spend.',
    audience:
      'ecommerce businesses with reliable fulfillment and margins that need ongoing campaign management. This service is for businesses that want product-level oversight rather than Merchant Center troubleshooting alone.',
    problemsHeading:
      'We address the issues limiting your Google Shopping return',
    problemsIntro:
      'Campaign settings are only one part of Shopping performance. Product economics and landing pages also matter. The feed must remain healthy. Merchant Center and conversion data must support the strategy. The budget must match the opportunity.',
    problems: [
      {
        title: 'Is your budget missing the products that can earn a return?',
        description:
          'Campaigns may distribute budget without enough attention to product economics. Margins and inventory should influence where money is spent. Seasonality and search behavior provide additional context. More orders do not necessarily mean better results if the products leave too little margin after advertising costs.',
      },
      {
        title: 'Are feed and Merchant Center issues limiting your visibility?',
        description:
          'Feed problems reduce the number of products eligible to appear. Disapprovals may come from weak product data or price mismatches. Shipping settings can create additional problems. Landing-page inconsistencies may also limit eligibility.',
      },
      {
        title: 'Is unreliable conversion data making optimization difficult?',
        description:
          'Missing, duplicated, or poorly defined purchase tracking makes automated bidding and return-on-ad-spend reporting unreliable.',
      },
    ],
    deliverablesHeading: 'What our Google Shopping management service includes',
    deliverablesIntro:
      'We manage the campaigns and coordinate the supporting measurement and product-data work included in scope. This keeps campaign decisions connected to the store and Merchant Center.',
    deliverables: [
      {
        title: 'Account and tracking review',
        description:
          'We review Google Ads and the available revenue history first.',
      },
      {
        title: 'Campaign structure and budgets',
        description:
          'We organize Shopping and Performance Max campaigns around business priorities and available budget.',
      },
      {
        title: 'Product-feed coordination',
        description:
          'We identify product-feed errors and update the product information included in your plan.',
      },
      {
        title: 'Ongoing optimization',
        description:
          'We compare spend and revenue at the campaign and product level.',
      },
      {
        title: 'Merchant Center monitoring',
        description:
          'We monitor the account and item issues included in scope.',
      },
      {
        title: 'Revenue-focused reporting',
        description:
          'Reporting connects campaign performance with revenue and conversion cost.',
      },
    ],
    platforms: [
      'Google Ads',
      'Google Shopping',
      'Performance Max',
      'Google Merchant Center',
      'GA4',
      'Google Tag Manager',
      'Shopify',
      'BigCommerce',
    ],
    credentials: [
      'Google Partner with ecommerce paid-search and conversion-tracking experience.',
      'Shopify Partner and BigCommerce Partner experience for coordinating store and feed changes.',
      'Monthly reporting that connects completed campaign work with revenue and cost data.',
    ],
    processIntro:
      'Management begins with reliable measurement and eligible products. From there, we use structured testing and ongoing optimization, then explain the results through transparent reporting.',
    process: [
      {
        title: 'We check your tracking and product eligibility',
        description:
          'We confirm account access and purchase measurement before making campaign decisions. Merchant Center status, feed sources, product eligibility, and campaign history establish the starting point.',
      },
      {
        title: 'We plan your campaigns and budget',
        description:
          'We define the campaign structure and budget around the business goals. Product priorities and targets guide the setup. Exclusions and landing-page needs are documented. The management plan also assigns feed responsibilities.',
      },
      {
        title: 'We launch or improve your campaigns',
        description:
          'We implement the approved Shopping and Performance Max changes. In-scope feed issues are addressed, and we check that your ads are running and purchases are being recorded correctly.',
      },
      {
        title: 'We manage performance and report results',
        description:
          'We compare product and query performance with cost and revenue. Conversion, budget, and eligibility data provide the context for documented decisions and next steps.',
      },
    ],
    faqs: [
      {
        question: 'Do you manage both standard Shopping and Performance Max?',
        answer:
          'Yes. The recommended structure depends on the account and product data. Conversion history affects the available options. Budget and business goals shape the final approach. We also consider how much control the business needs.',
      },
      {
        question: 'Will you fix our Google Merchant Center feed?',
        answer:
          'We resolve feed and Merchant Center issues included in the management scope and coordinate required store or feed-tool changes. Large remediation projects may need a separate scope.',
      },
      {
        question: 'How much should we spend on Google Shopping?',
        answer:
          'Budget should reflect product economics and available demand. Geography and competition affect the cost of reaching buyers. Conversion history shows how much evidence already exists. We recommend a responsible starting range after reviewing the account.',
      },
      {
        question: 'Can you guarantee a target return on ad spend?',
        answer:
          'No. We can manage toward agreed business targets and report clearly. Demand and competition remain outside any agency’s control. Pricing and margins influence the result. Inventory and website quality matter as well. Customer behavior can also change performance.',
      },
      {
        question: 'What reporting will we receive?',
        answer:
          'Reporting connects spend with revenue and conversion cost. Return on ad spend provides another view of efficiency. We explain campaign and product observations in plain language. The report also records completed work and material issues. It closes with the next priorities.',
      },
    ],
  },
  {
    path: '/google-merchant-center-services',
    slug: 'google-merchant-center-services',
    breadcrumbName: 'Google Merchant Center Services',
    metaTitle: 'Google Merchant Center Services',
    metaDescription:
      'Set up and troubleshoot Google Merchant Center, resolve product-data errors, coordinate store and feed corrections, and restore Shopping readiness.',
    serviceName: 'Google Merchant Center Services',
    serviceType:
      'Google Merchant Center Setup and Product Feed Troubleshooting',
    eyebrow: 'Product Feed and Shopping Readiness',
    heroBefore: 'Google ',
    heroHighlight: 'Merchant Center',
    heroAfter: ' Services',
    heroAllBlack: true,
    heroDescription:
      'We set up and troubleshoot Google Merchant Center to correct product-data errors and help your products meet Google’s listing requirements.',
    intro:
      'Ventura helps ecommerce teams set up and troubleshoot Google Merchant Center accounts and feeds. The goal is reliable product data and a clear path for resolving issues that limit Shopping eligibility.',
    audience:
      'ecommerce merchants that need Merchant Center setup or focused troubleshooting. Choose this service when account and feed health are the primary problem, rather than ongoing campaign management.',
    problemsHeading: 'We resolve the issues behind your Merchant Center errors',
    problemsIntro:
      'A warning displayed in Google does not always originate in Merchant Center. The problem may come from the store or its feed rules. Product data can also be responsible. Website policies and structured data provide other possible sources.',
    problems: [
      {
        title: 'Are your products disapproved or limited?',
        description:
          'Products can be limited when Google cannot verify their identity or current purchase information. Image issues, policy violations, and unsupported destinations can also stop products from appearing in Google’s listings or ads.',
      },
      {
        title: 'Does your store data disagree with your product feed?',
        description:
          'Merchant Center depends on the store and feed remaining synchronized. Price and availability must match. Shipping information and destination URLs must also agree. Structured data can trigger errors when it conflicts with the feed.',
      },
      {
        title: 'Are you being passed between support teams?',
        description:
          'Merchant Center issues often cross several systems. Each vendor may see only one part of the problem, leaving the merchant without a clear owner for the complete resolution.',
      },
    ],
    deliverablesHeading: 'What our Google Merchant Center services include',
    deliverablesIntro:
      'We trace errors to their source, define the responsible fix, and verify how Merchant Center processes the corrected information.',
    deliverables: [
      {
        title: 'Account setup and store connection',
        description:
          'We review account access and core business information first.',
      },
      {
        title: 'Feed-source review',
        description: 'We identify how product data reaches Merchant Center.',
      },
      {
        title: 'Product error diagnosis',
        description:
          'We investigate the source of product warnings and disapprovals that affect your listings.',
      },
      {
        title: 'Shipping and tax alignment',
        description:
          'We compare Merchant Center settings with the ecommerce store and agreed customer experience to address mismatches and incomplete configuration.',
      },
      {
        title: 'Store and structured-data coordination',
        description:
          'We check that product-page information and structured data agree with your feed.',
      },
      {
        title: 'Verification and monitoring plan',
        description:
          'We request reprocessing or review where appropriate and monitor the resulting status.',
      },
    ],
    platforms: [
      'Google Merchant Center',
      'Google Ads',
      'Shopify Google and YouTube',
      'BigCommerce feeds',
      'Feedonomics',
      'GA4',
      'Product structured data',
      'Supplemental feeds',
    ],
    credentials: [
      'Google Partner with experience coordinating Merchant Center, Google Ads, analytics, and ecommerce platforms.',
      'Shopify Partner and BigCommerce Partner experience for resolving source-store issues.',
      'Direct product-feed and conversion-tracking work across ecommerce campaigns and launches.',
    ],
    processIntro:
      'We start with the current account evidence, trace each material issue to the responsible system, make approved corrections, and monitor Google’s response.',
    process: [
      {
        title: 'We review your account and product feed',
        description:
          'We inspect account-level notices and material item issues. Feed sources and linked platforms show where data originates. Policies and shipping settings may explain account restrictions. Tax settings and website status provide additional evidence.',
      },
      {
        title: 'We find what is causing the errors',
        description:
          'We identify the system responsible for each issue. The correction may belong in Merchant Center or the feed tool. Other problems begin in the ecommerce platform. Product records and website content may also require changes.',
      },
      {
        title: 'We make the agreed corrections',
        description:
          'We complete the approved corrections within scope. Any dependencies owned by the client, platform, feed vendor, or another provider are documented.',
      },
      {
        title: 'We check Google’s response and explain any remaining issues',
        description:
          'We monitor item status and request review where appropriate. Representative products are tested, and unresolved or recurring issues are documented.',
      },
    ],
    faqs: [
      {
        question: 'Can you fix product disapprovals in Google Merchant Center?',
        answer:
          'We can diagnose issues in the accessible account and feed. Product data and the ecommerce platform may require correction. We can also address structured data and website content. Google retains final control over review and approval.',
      },
      {
        question:
          'Why does Merchant Center say our price or availability is wrong?',
        answer:
          'The feed may disagree with the product page or structured data. Variant selection can expose a different price. Sale timing and currency may also create mismatches. We compare each system to find where the disagreement begins.',
      },
      {
        question: 'Do you work with Shopify and BigCommerce product feeds?',
        answer:
          'Yes. We review native and app-supported feeds from Shopify and BigCommerce and can coordinate selected feed platforms or supplemental sources when needed.',
      },
      {
        question: 'Can you guarantee that Google will approve our account?',
        answer:
          'No. We can correct identifiable issues and request review where available. Google controls policy interpretation and processing. Google also controls approval and suspension decisions. Final program eligibility remains outside the agency’s control.',
      },
      {
        question: 'Do we need ongoing Merchant Center monitoring?',
        answer:
          'Ongoing monitoring is valuable for active catalogs. Price and inventory change frequently. Images and policies also evolve. Shipping updates or website changes can introduce new errors. Google requirements may create additional issues over time.',
      },
    ],
  },
  {
    path: '/klaviyo-email-marketing-agency',
    slug: 'klaviyo-email-marketing-agency',
    breadcrumbName: 'Klaviyo Email Marketing Agency',
    metaTitle: 'Klaviyo Email Marketing Agency',
    metaDescription:
      'Build a reliable Klaviyo program with ecommerce integration and lifecycle automation. Improve campaigns through deliverability and revenue reporting.',
    serviceName: 'Klaviyo Email Marketing Agency Services',
    serviceType: 'Klaviyo Email and SMS Marketing',
    eyebrow: 'Ecommerce Retention Marketing',
    heroBefore: '',
    heroHighlight: 'Klaviyo',
    heroAfter: ' Email Marketing Agency',
    heroDescription:
      'We build and manage Klaviyo email and SMS campaigns that reach customers with relevant messages at the right time.',
    intro:
      'Ventura helps ecommerce brands establish a reliable Klaviyo foundation. We improve the communication customers receive over time. Account setup connects with automated flows and campaigns. SMS can remain part of the program. Deliverability and revenue reporting guide improvement.',
    audience:
      'Shopify and BigCommerce teams that need a dependable Klaviyo partner. We can build the account foundation or improve an inherited setup. The relationship can also continue as an ongoing retention program.',
    problemsHeading: 'We close the gaps in your Klaviyo email program',
    problemsIntro:
      'Sending more email is not the same as building a useful lifecycle program. Customer data and consent must support relevant messages. Timing and creative shape the customer experience. Deliverability and measurement guide improvement.',
    problems: [
      {
        title: 'Are important lifecycle flows missing or outdated?',
        description:
          'Important automated messages may be missing or no longer match the store. Welcome and abandonment flows should reflect the current brand, products, and customer journey, as should post-purchase and win-back communication.',
      },
      {
        title: 'Are your campaigns reaching everyone with the same message?',
        description:
          'Sending the same message to most of the list reduces relevance. Useful segmentation distinguishes active customers and prospects from profiles that should receive less frequent communication.',
      },
      {
        title: 'Is revenue reporting hiding setup and deliverability problems?',
        description:
          'Revenue reporting becomes difficult to trust when the account foundation is weak. Duplicate events or attribution settings can distort results. Consent and list quality provide necessary context. Integration gaps can create additional errors.',
      },
    ],
    deliverablesHeading: 'What our Klaviyo services include',
    deliverablesIntro:
      'The engagement can begin with a defined account project and continue into monthly support. Ongoing work can include campaigns, testing, segmentation, and reporting.',
    deliverables: [
      {
        title: 'Store connection and account setup',
        description:
          'We review the ecommerce integration and the events flowing into Klaviyo.',
      },
      {
        title: 'Signup forms and list growth',
        description: 'We plan and configure the selected signup forms.',
      },
      {
        title: 'Automated email and SMS flows',
        description:
          'We build or improve the lifecycle flows included in scope.',
      },
      {
        title: 'Audience targeting and list cleanup',
        description:
          'We create practical customer and engagement segments and maintain suppression rules that support relevance and deliverability.',
      },
      {
        title: 'Campaign planning and production',
        description:
          'We coordinate the promotional calendar with campaign strategy and production.',
      },
      {
        title: 'Testing and performance reporting',
        description:
          'We review deliverability and engagement alongside conversions and attributed revenue.',
      },
    ],
    platforms: [
      'Klaviyo',
      'Shopify',
      'Shopify Plus',
      'BigCommerce',
      'Klaviyo SMS',
      'Product feeds',
      'Review integrations',
      'Branded sending domains',
    ],
    credentials: [
      'Klaviyo Partner with ecommerce-platform integration and lifecycle-flow experience.',
      'Shopify Partner and BigCommerce Partner experience for coordinating catalog, event, form, and storefront changes.',
      'Email work that can coordinate with website promotions, paid media, social, merchandising, and analytics.',
    ],
    processIntro:
      'We establish trustworthy data and priorities before building automation, then use real engagement and revenue evidence to improve the program over time.',
    process: [
      {
        title: 'We review your Klaviyo account',
        description:
          'We review the account foundation and performance history before changing the program. Events and consent show whether the data is usable. Lists and forms reveal how profiles enter the account. Domains and deliverability expose sending risks. Customer segments show whether automation can remain relevant.',
      },
      {
        title: 'We plan your automated messages and campaigns',
        description:
          'We prioritize foundational corrections before new automation. We decide which automated messages your customers need and who should receive them. Offers and creative needs shape the messages. Sending cadence and measurement complete the working plan.',
      },
      {
        title: 'We create, test, and launch your messages',
        description:
          'We create your approved signup forms, emails, and SMS messages. Before launch, we verify the content and links. Events and audience rules receive their own tests. We also check account settings and message rendering.',
      },
      {
        title: 'We report results and improve performance',
        description:
          'We review deliverability and engagement alongside conversions and revenue. List quality, customer behavior, and completed tests inform the next priorities.',
      },
    ],
    faqs: [
      {
        question: 'Which Klaviyo flows should an ecommerce store have?',
        answer:
          'Common priorities include welcome and abandonment messages, followed by post-purchase and win-back communication. The right sequence depends on the products and purchase cycle as well as the quality of the existing data and program.',
      },
      {
        question: 'Can you take over an existing Klaviyo account?',
        answer:
          'Yes. We first audit the account foundation and ecommerce integration. Then we review consent and audience quality. Forms and automation receive a separate assessment. We also inspect current campaigns. Templates and deliverability are checked before changes are made. Attribution provides the reporting context.',
      },
      {
        question: 'Do you manage monthly Klaviyo campaigns?',
        answer:
          'Yes. Ongoing engagements can include campaign planning and production. Copy and design can remain part of that work. Product selection and audience segmentation support each send. Testing and scheduling happen before launch. Reporting and flow improvements continue through the monthly program.',
      },
      {
        question: 'Can you improve Klaviyo deliverability?',
        answer:
          'We can improve the parts of deliverability the sender controls. That includes the sending domain and consent practices. Audience targeting and list cleanup protect engagement. List quality and content matter as well. Sending cadence must match audience behavior. No agency can guarantee inbox placement.',
      },
      {
        question: 'Do you support both email and SMS in Klaviyo?',
        answer:
          'Yes, when SMS is appropriate for the audience and included in scope. Consent and sending rules require careful planning. Fees and content affect the program. Message frequency must be coordinated with email.',
      },
    ],
  },
  {
    path: '/ecommerce-website-maintenance',
    slug: 'ecommerce-website-maintenance',
    breadcrumbName: 'Ecommerce Website Maintenance',
    metaTitle: 'Ecommerce Website Maintenance Services',
    metaDescription:
      'Maintain an active ecommerce store through dependable theme and app support. Keep catalog updates and technical coordination moving.',
    serviceName: 'Ecommerce Website Maintenance Services',
    serviceType: 'Ongoing Ecommerce Website Maintenance',
    eyebrow: 'Ongoing Ecommerce Support',
    heroBefore: 'Ecommerce ',
    heroHighlight: 'Website Maintenance',
    heroAfter: '',
    heroDescription:
      'We provide dependable ongoing maintenance for ecommerce stores that need fixes, updates, merchandising support, and technical troubleshooting.',
    intro:
      'Ventura maintains ecommerce websites through a prioritized queue of technical and storefront work. Our cross-platform service connects theme and app support with catalog updates, merchandising, analytics, and vendor coordination.',
    audience:
      'small and midsize ecommerce businesses that need reliable ongoing help across the store. Merchants seeking support centered specifically on Shopify or BigCommerce can use the corresponding platform service.',
    problemsHeading: 'We keep website issues from slowing your business down',
    problemsIntro:
      'Ecommerce websites change continuously as products, promotions, apps, and platforms evolve. Small unresolved issues can compound quickly and create avoidable risk.',
    problems: [
      {
        title: 'Do your website updates keep getting pushed back?',
        description:
          'Routine requests wait because no one owns the complete queue. Theme fixes and product updates compete with app conflicts, broken tracking, promotions, and usability issues.',
      },
      {
        title: 'Is your current agency or developer unreliable?',
        description:
          'Requests disappear, response times are unpredictable, documentation is missing, and the business lacks confidence that urgent store problems will be handled.',
      },
      {
        title: 'Does your internal team need broader ecommerce expertise?',
        description:
          'Internal staff may manage routine updates but need support when a problem needs both technical and marketing expertise. Ventura coordinates the technical and marketing work so the client does not have to assemble a new team for each request.',
      },
    ],
    deliverablesHeading:
      'What our ecommerce website maintenance service includes',
    deliverablesIntro:
      'Maintenance priorities are agreed with the client and completed within the documented scope. Available time, access, and platform limits shape what can be completed in each cycle.',
    deliverables: [
      {
        title: 'Theme fixes and enhancements',
        description:
          'We diagnose customer-facing theme problems and improve the affected experience.',
      },
      {
        title: 'App and technical troubleshooting',
        description:
          'We investigate technical problems that cross the theme and connected systems.',
      },
      {
        title: 'Catalog and content updates',
        description: 'We help keep the catalog and website content current.',
      },
      {
        title: 'Promotions and merchandising',
        description:
          'We deploy approved promotions and seasonal storefront updates.',
      },
      {
        title: 'Analytics, speed, and conversion work',
        description:
          'We fix tracking problems and work on the speed and conversion improvements included in your plan.',
      },
      {
        title: 'Vendor and platform coordination',
        description:
          'We coordinate with ecommerce platforms and outside providers when an issue crosses systems.',
      },
    ],
    platforms: [
      'Shopify',
      'Shopify Plus',
      'BigCommerce',
      'WooCommerce',
      'GA4',
      'Google Tag Manager',
      'Klaviyo',
      'Ecommerce apps and vendors',
    ],
    credentials: [
      'Shopify Partner and BigCommerce Partner experience across active ecommerce stores.',
      'More than 25 years of ecommerce development, design, marketing, and operational support.',
      'A U.S.-based team that can coordinate technical, catalog, marketing, analytics, and vendor needs.',
    ],
    processIntro:
      'We begin with an inherited-store review, establish access and priorities, then maintain a visible queue of work that can evolve with the business.',
    process: [
      {
        title: 'We review your store and outstanding issues',
        description:
          'We inspect the current platform and theme before changing the store. We check the apps your store uses and confirm that we have the access needed to work on it. Analytics and recent work show what has changed. We also document known issues and vendors. The existing backlog establishes the first priorities.',
      },
      {
        title: 'We agree on priorities with you',
        description:
          'We define how requests enter the queue and who approves them. Available hours and communication rules are documented. Risk and vendor ownership guide escalation. The client confirms the first priorities.',
      },
      {
        title: 'We complete and test your updates',
        description:
          'We investigate your requests, complete and test the agreed updates, and keep you informed of progress. We flag larger requests that need a separate project.',
      },
      {
        title: 'We review upcoming work with you',
        description:
          'We revisit the backlog as the business changes. Promotions, products, platform releases, and performance evidence can shift the priority of future requests.',
      },
    ],
    faqs: [
      {
        question:
          'Can you take over maintenance from another agency or developer?',
        answer:
          'Yes. We begin with access and platform review. The theme and active apps receive their own assessment. Analytics and vendor relationships provide additional context. We also review the backlog so inherited risks are visible before material changes.',
      },
      {
        question:
          'What kinds of ecommerce maintenance requests can you handle?',
        answer:
          'Common work includes theme and app troubleshooting. Catalog updates and promotions may also lead the queue. Landing pages and tracking can be handled through the same relationship. Store performance and accessibility can become later priorities. Conversion improvements and vendor coordination may follow as needs evolve.',
      },
      {
        question: 'Do we have to sign a long-term maintenance contract?',
        answer:
          'Engagement options can include hourly support blocks and ongoing support plans. The final agreement explains the term, available time, communication, and renewal or cancellation rules.',
      },
      {
        question: 'How quickly will maintenance requests be completed?',
        answer:
          'Timing depends on priority and complexity. Available hours and access also affect completion. Some requests require client approval. Platform behavior or outside vendors may create delays. Any response commitment must be stated in the agreement.',
      },
      {
        question:
          'What happens when a request is too large for maintenance time?',
        answer:
          'We explain the risk and likely effort first. Then we recommend a separate discovery or project scope when appropriate. Broader design work may need that treatment. The same is true for migrations and complex integrations.',
      },
    ],
  },
  {
    path: '/shopify-support-maintenance',
    slug: 'shopify-support-maintenance',
    breadcrumbName: 'Shopify Support and Maintenance',
    metaTitle: 'Shopify Support and Maintenance Services',
    metaDescription:
      'Get dependable Shopify theme and app support. Keep catalog updates and promotions moving through ongoing technical troubleshooting.',
    serviceName: 'Shopify Support and Maintenance Services',
    serviceType: 'Ongoing Shopify Store Support and Maintenance',
    eyebrow: 'Ongoing Shopify Support',
    heroBefore: '',
    heroHighlight: 'Shopify',
    heroAfter: ' Support and Maintenance',
    heroDescription:
      'We provide dependable ongoing Shopify support for stores that need technical help, routine updates, and continuous improvement.',
    intro:
      'Ventura supports existing Shopify and Shopify Plus stores through an ongoing queue of storefront and technical work. We connect theme and app support with catalog updates, promotions, analytics, and vendor coordination.',
    audience:
      'Shopify merchants that need a reliable U.S.-based partner to inherit, maintain, troubleshoot, and improve an active store over time.',
    problemsHeading:
      'We solve the Shopify issues your team cannot keep up with',
    problemsIntro:
      'A maintenance relationship gives the business a consistent team that understands the store. That shared knowledge prevents every request from starting with a new explanation of the theme, apps, catalog, and business priorities.',
    problems: [
      {
        title: 'Do theme and app changes keep creating new issues?',
        description:
          'Theme code and app behavior can become difficult to separate after years of changes. Vendor updates, old snippets, and duplicated theme copies make even small problems harder to diagnose safely.',
      },
      {
        title: 'Do store updates depend on whoever happens to be available?',
        description:
          'Routine storefront work is delayed or completed inconsistently. Promotions and product updates may compete with policies, tracking, landing pages, and customer-experience improvements.',
      },
      {
        title: 'Are you looking to replace an unresponsive agency?',
        description:
          'You do not have a reliable way to request updates or someone accountable for technical problems. Missing documentation and inconsistent support make it harder to keep the store running after the original build or a change of agency.',
      },
    ],
    deliverablesHeading: 'What our Shopify support service includes',
    deliverablesIntro:
      'We prioritize work with the client and use native Shopify capabilities before adding unnecessary apps or custom code.',
    deliverables: [
      {
        title: 'Liquid and theme support',
        description:
          'We maintain Shopify themes and the responsive storefront behavior they produce.',
      },
      {
        title: 'App setup and troubleshooting',
        description:
          'We set up and troubleshoot the selected Shopify apps included in scope.',
      },
      {
        title: 'Catalog and merchandising',
        description:
          'We help update your products and collections and organize how they appear in your store.',
      },
      {
        title: 'Checkout and operational issues',
        description:
          'We investigate concerns that affect the path from cart to order.',
      },
      {
        title: 'Speed, SEO, accessibility, and CRO',
        description:
          'We complete the agreed improvements to store performance and customer experience.',
      },
      {
        title: 'Analytics and launch coordination',
        description:
          'We help check your tracking and coordinate the release of storefront updates.',
      },
    ],
    platforms: [
      'Shopify',
      'Shopify Plus',
      'Liquid',
      'Online Store 2.0',
      'Shopify apps',
      'GA4',
      'Google Tag Manager',
      'Klaviyo',
    ],
    credentials: [
      'Shopify Partner with storefront, theme, migration, catalog, app, and post-launch experience.',
      'A U.S.-based team that can coordinate development, SEO, paid search, email, analytics, and merchandising.',
      'Support options for hourly needs and ongoing relationships rather than build-and-disappear delivery.',
    ],
    processIntro:
      'We learn the inherited Shopify setup, establish a safe working process, and build context over time so each request does not start from zero.',
    process: [
      {
        title: 'We review your Shopify store',
        description:
          'We inspect the current themes and apps before changing the store. User access and analytics provide the operating context. Domains and recent work show what has changed. We also document known issues and vendors. The backlog establishes the first priorities.',
      },
      {
        title: 'We organize your support requests',
        description:
          'We agree on how you submit requests, how priorities are approved, and the support time available. We also define how changes will be tested before they go live and who will coordinate with outside vendors.',
      },
      {
        title: 'We complete and test the changes',
        description:
          'We complete approved work in controlled environments when practical, test the affected pages and explain any related app or platform requirements.',
      },
      {
        title: 'We plan the next improvements with you',
        description:
          'We update priorities as store needs and customer feedback change. Platform releases, campaign calendars, and available performance evidence also shape the roadmap.',
      },
    ],
    faqs: [
      {
        question:
          'Can you take over an existing Shopify store from another agency?',
        answer:
          'Yes. We first review store access and the inherited technical setup. Themes and apps establish the development context. Custom code receives a separate review. Analytics and domains show how the store is connected. We also document vendors and open issues. Recent changes are reviewed before major work begins.',
      },
      {
        question:
          'Do you provide Shopify support after another company built the store?',
        answer:
          'Yes. Ventura can maintain stores built by another agency or freelancer. We can also inherit work from an internal team or theme vendor. An initial review of the current setup and access still applies.',
      },
      {
        question: 'Can you fix Shopify theme and app conflicts?',
        answer:
          'We can investigate theme code and app embeds. Scripts and settings receive their own review. Event behavior may reveal a deeper integration problem. Vendor dependencies are documented. Some issues require cooperation from Shopify or the app provider.',
      },
      {
        question: 'Can you help with products, collections, and promotions?',
        answer:
          'Yes. Maintenance can include product and collection updates. Metafields and images may also require routine work. Search and filters can become separate priorities. We support landing pages and seasonal merchandising as well. That work may include discounts or banners.',
      },
      {
        question: 'Do you offer Shopify support without a long project?',
        answer:
          'Yes. Hourly support blocks are suitable for prioritized requests and troubleshooting. Ongoing plans are available when the store needs recurring attention and continuity.',
      },
    ],
  },
  {
    path: '/bigcommerce-support-maintenance',
    slug: 'bigcommerce-support-maintenance',
    breadcrumbName: 'BigCommerce Support and Maintenance',
    metaTitle: 'BigCommerce Support and Maintenance',
    metaDescription:
      'Get dependable BigCommerce support for Stencil and app issues. Keep catalog updates and integrations moving through ongoing troubleshooting.',
    serviceName: 'BigCommerce Support and Maintenance Services',
    serviceType: 'Ongoing BigCommerce Store Support and Maintenance',
    eyebrow: 'Ongoing BigCommerce Support',
    heroBefore: '',
    heroHighlight: 'BigCommerce',
    heroAfter: ' Support and Maintenance',
    heroDescription:
      'We provide dependable ongoing BigCommerce support for stores that need technical help, routine updates, and continuous improvement.',
    intro:
      'Ventura supports active BigCommerce stores through an ongoing queue of storefront and technical work. We connect Stencil and integration support with catalog updates, analytics, conversion work, and vendor coordination.',
    audience:
      'BigCommerce and BigCommerce Enterprise merchants that need a reliable development and ecommerce team to inherit, maintain, and improve an established store.',
    problemsHeading: 'We bring reliable support to your BigCommerce store',
    problemsIntro:
      'A dependable support relationship preserves knowledge as the store changes. The same team can connect technical history with current business priorities instead of treating each request in isolation.',
    problems: [
      {
        title: 'Are your Stencil theme and custom code poorly documented?',
        description:
          'Years of Stencil and integration changes can make small requests risky. Theme copies, custom components, scripts, and prior agency work need context before they are changed.',
      },
      {
        title: 'Is catalog and operational work piling up?',
        description:
          'Catalog and operational work continues after launch. Product information and categories change alongside feeds, shipping rules, promotions, and policies.',
      },
      {
        title: 'Do you need one team to coordinate your vendors?',
        description:
          'Several providers may control different parts of the customer experience. Ventura coordinates directly with BigCommerce and app vendors. Some problems also require help from your payment or shipping provider. Feed tools and analytics can reveal additional issues. Marketing teams remain informed when storefront work affects campaigns.',
      },
    ],
    deliverablesHeading: 'What our BigCommerce support service includes',
    deliverablesIntro:
      'We prioritize requests, work within the current platform architecture, and identify larger projects before maintenance time is consumed by uncontrolled scope.',
    deliverables: [
      {
        title: 'Stencil theme maintenance',
        description:
          'We maintain Stencil themes and the responsive storefront behavior they produce.',
      },
      {
        title: 'Apps and integrations',
        description:
          'We investigate problems involving selected apps and connected services.',
      },
      {
        title: 'Catalog and category support',
        description:
          'We help update your products and categories so customers can find the right items.',
      },
      {
        title: 'Cart, checkout, shipping, and payments',
        description:
          'We troubleshoot concerns that affect the path from cart to order.',
      },
      {
        title: 'SEO, speed, accessibility, and CRO',
        description:
          'We complete the agreed improvements to store performance and customer experience.',
      },
      {
        title: 'Analytics and campaign support',
        description:
          'We support measurement and campaign-related storefront work.',
      },
    ],
    platforms: [
      'BigCommerce',
      'BigCommerce Enterprise',
      'Stencil',
      'Page Builder',
      'BigCommerce apps',
      'GA4',
      'Google Tag Manager',
      'Product feeds',
    ],
    credentials: [
      'BigCommerce Partner and BigCommerce-certified development experience.',
      'More than 25 years of ecommerce support across platforms, catalogs, integrations, and marketing programs.',
      'A U.S.-based team that can coordinate technical, SEO, paid media, email, analytics, and merchandising work.',
    ],
    processIntro:
      'We review the inherited BigCommerce environment first, then use a controlled request and testing process that builds useful store context over time.',
    process: [
      {
        title: 'We review your BigCommerce store',
        description:
          'We inspect current users and themes before changing the store. We review your Stencil theme changes and apps to understand how your store has been customized. Analytics and feeds show how the store connects with outside systems. Domains and vendors are documented separately. We also review open issues and recent work.',
      },
      {
        title: 'We agree on support priorities with you',
        description:
          'We define how requests enter the queue and how they are approved. Available time and testing rules are documented. Theme-release procedures follow the same process. Communication and escalation have clear owners.',
      },
      {
        title: 'We complete and test your requests',
        description:
          'We investigate, implement, and verify maintenance requests while explaining when a request depends on another provider or needs a larger project.',
      },
      {
        title: 'We keep your support plan up to date',
        description:
          'We update the queue as the business evolves. Platform releases and catalog changes may create new work. Promotions can change the immediate priority. Performance evidence and operational needs guide what follows.',
      },
    ],
    faqs: [
      {
        question:
          'Can you take over a BigCommerce store built by another agency?',
        answer:
          'Yes. We begin with an inherited-store review covering access and the current setup. Themes and Stencil code establish the development context. Apps and catalog structures reveal dependencies. Analytics and feeds show how outside systems connect. We also document vendors and current issues.',
      },
      {
        question: 'Do you work with BigCommerce Stencil themes?',
        answer:
          'Yes. Ventura has BigCommerce-certified development experience. We support Stencil templates and custom components. Page Builder work can remain part of the same queue. CSS and JavaScript support responsive storefront behavior.',
      },
      {
        question: 'Can you maintain complex product options and custom fields?',
        answer:
          'Yes. We work with product variants and related options or modifiers. Custom fields and categories can also be supported. Images and bulk catalog data may require separate handling. The platform and app structure still determine what is possible.',
      },
      {
        question: 'Can you coordinate with BigCommerce and app support?',
        answer:
          'Yes. When an issue crosses systems, we document the evidence first. We then communicate with the relevant vendor and test proposed changes. The client remains informed about ownership and risk.',
      },
      {
        question: 'Do you offer both hourly and ongoing BigCommerce support?',
        answer:
          'Yes. Hourly blocks work for defined priorities and troubleshooting. Ongoing support is better for stores that need continuity, recurring updates, and an evolving backlog.',
      },
      {
        question: 'Can you improve Core Web Vitals on BigCommerce?',
        answer:
          'Yes. We assess key store pages for loading, interaction, and layout stability issues. We identify causes in theme code, images, scripts, and apps, make the agreed improvements, and measure the results again.',
      },
    ],
  },
  {
    path: '/ecommerce-consulting',
    slug: 'ecommerce-consulting',
    breadcrumbName: 'Ecommerce Consulting',
    metaTitle: 'Ecommerce Consulting Services',
    metaDescription:
      'Get practical ecommerce guidance for agency replacement and platform decisions. Clarify migration risk and growth priorities.',
    serviceName: 'Ecommerce Consulting Services',
    serviceType: 'Ecommerce Strategy and Agency Takeover Consulting',
    eyebrow: 'Independent Ecommerce Guidance',
    heroBefore: 'Ecommerce ',
    heroHighlight: 'Consulting',
    heroAfter: '',
    heroDescription:
      'We help ecommerce teams decide what to improve, which platform or provider fits, and what to do next.',
    intro:
      'Ventura helps ecommerce businesses diagnose inherited problems and evaluate difficult decisions. We turn platform, vendor, agency, and growth questions into an actionable roadmap.',
    audience:
      'owners facing a high-impact ecommerce decision. This also fits teams inheriting a difficult store or agency relationship. Migration questions and cross-functional backlogs can benefit from the same independent guidance.',
    problemsHeading: 'We help you resolve difficult ecommerce decisions',
    problemsIntro:
      'Consulting is useful when several paths appear possible and the consequences are significant. A poor decision can waste budget, increase migration risk, or deepen dependence on a weak setup.',
    problems: [
      {
        title: 'Is your current agency relationship no longer working?',
        description:
          'The current relationship may have broken down because of poor communication or unclear ownership. Quality and pace may also be concerns. Trust can disappear when those problems continue. Before replacing the agency, the business needs to know what should be preserved and what must change.',
      },
      {
        title: 'Are you worried about choosing the wrong platform or provider?',
        description:
          'Platforms and vendors solve different problems and create different operating commitments. The best choice depends on the business requirement, not the popularity of a particular tool.',
      },
      {
        title: 'Does every team have a different priority?',
        description:
          'Internal teams often compete for the same budget without a shared roadmap. Consulting connects technical, marketing, operational, and leadership priorities so your team can agree on what to tackle first.',
      },
    ],
    deliverablesHeading: 'What our ecommerce consulting service includes',
    deliverablesIntro:
      'Ventura’s consulting draws from hands-on ecommerce implementation and long-term support. That experience includes development and migrations. It also includes marketing and analytics. Catalog operations and vendor coordination provide an operational perspective.',
    deliverables: [
      {
        title: 'Store and account assessment',
        description:
          'We review your store, connected tools, and the problems you want to solve.',
      },
      {
        title: 'Agency takeover planning',
        description:
          'We identify what the business must protect before the prior relationship ends.',
      },
      {
        title: 'Platform and migration guidance',
        description:
          'We compare platforms against the way the business actually operates.',
      },
      {
        title: 'Technology and vendor recommendations',
        description:
          'We assess technology and vendor options against the actual requirement.',
      },
      {
        title: 'Growth and improvement roadmap',
        description:
          'We organize competing initiatives into one improvement roadmap.',
      },
      {
        title: 'Scope and technical-risk review',
        description:
          'We identify assumptions and unknowns before a larger project begins.',
      },
    ],
    platforms: [
      'Shopify and Shopify Plus',
      'BigCommerce and Enterprise',
      'WooCommerce',
      'Klaviyo',
      'Google Ads and Merchant Center',
      'GA4 and Tag Manager',
      'Semrush and Search Console',
      'Ecommerce apps and vendors',
    ],
    credentials: [
      'More than 25 years of ecommerce work and over 1,000 website launches.',
      'Shopify Partner, BigCommerce Partner, Google Partner, Klaviyo Partner, and Semrush Agency Partner relationships represented on Ventura’s website.',
      'A cross-functional U.S.-based team with direct implementation and ongoing support experience.',
    ],
    processIntro:
      'We define the decision and gather the evidence needed to evaluate it. Then we compare the viable options and document the recommended next step and its owner.',
    process: [
      {
        title: 'We clarify the decision you need to make',
        description:
          'We clarify the decision and the desired business outcome. Stakeholders and deadlines establish who is involved. We discuss your budget and any limits that affect the options. The cost of delay helps determine urgency.',
      },
      {
        title: 'We review your store and current setup',
        description:
          'We inspect the relevant store and supporting accounts. Available data provides performance evidence. Vendors and client-provided scopes reveal current obligations. Documentation and the technical setup provide additional context.',
      },
      {
        title: 'We explain your options',
        description:
          'We compare the viable choices in plain language. The comparison explains dependencies and risk. It also addresses effort and sequencing. Ownership is made explicit. Any information that remains unknown is documented.',
      },
      {
        title: 'We recommend a practical plan',
        description:
          'We document the priorities and anything you need to secure or preserve before making changes. Recommended projects, internal responsibilities, vendor needs, and the next decision point form the roadmap.',
      },
    ],
    faqs: [
      {
        question: 'Can you help us replace our current ecommerce agency?',
        answer:
          'Yes. We identify the access and ownership the business must protect. Active vendors and accounts receive a separate review. We also inspect the current theme and apps. Open work and existing documentation reveal transition risk. Those findings shape the next steps.',
      },
      {
        question:
          'Can you tell us whether Shopify or BigCommerce is the better fit?',
        answer:
          'We compare each platform with the business model and catalog requirements. B2B needs and daily operations influence the fit. Integrations and internal capabilities also matter. Budget and migration risk shape the practical choice. Long-term ownership is considered before we recommend a direction.',
      },
      {
        question: 'Will you recommend tools or agencies other than Ventura?',
        answer:
          'Yes, when the requirement is outside our expertise or another specialist is a better fit. You will still need to review the provider’s proposal and terms before hiring them.',
      },
      {
        question: 'Can consulting turn into implementation work?',
        answer:
          'Yes. Ventura can scope selected implementation work after the priorities are clear. The next step may involve development or migration. Maintenance can support an inherited environment. We can also provide SEO and paid media. Email and analytics may remain part of the broader recommendation.',
      },
      {
        question:
          'What should we prepare before an ecommerce consulting engagement?',
        answer:
          'Prepare the decision you need to make and the major problems behind it. Relevant access and current vendors provide context. Known contracts or scopes reveal existing obligations. Performance data and platform details support the analysis. The discussion should also include budget context and the people who own approval.',
      },
    ],
  },
  {
    path: '/ecommerce-website-audit',
    slug: 'ecommerce-website-audit',
    breadcrumbName: 'Ecommerce Website Audit',
    metaTitle: 'Ecommerce Website Audit Services',
    metaDescription:
      'Diagnose the complete ecommerce experience. Receive one roadmap for the storefront and its supporting technology and marketing systems.',
    serviceName: 'Ecommerce Website Audit Services',
    serviceType: 'Comprehensive Ecommerce Website and Growth Audit',
    eyebrow: 'Complete Ecommerce Website Review',
    heroBefore: 'Ecommerce ',
    heroHighlight: 'Website Audit',
    heroAfter: '',
    heroDescription:
      'We check your online store and the tools you use to run it. Then we give you a clear plan and show you what to fix first.',
    intro:
      'Ventura evaluates how the storefront, technology, operations, and marketing systems work together. We organize the most important customer and business problems into one practical roadmap.',
    audience:
      'ecommerce businesses that know the store underperforms or feels difficult to manage but do not yet know which discipline should lead the solution. Choose the ecommerce SEO audit instead when organic search is the primary concern.',
    problemsHeading: 'We turn store problems into a clear improvement plan',
    problemsIntro:
      'A holistic audit is broader than an SEO or advertising review. It examines how the storefront and technology affect operations, customer behavior, and growth channels.',
    problems: [
      {
        title:
          'Are your customers encountering friction across the buying journey?',
        description:
          'Customers experience the store as one journey even when internal teams manage it in separate parts. Product discovery and evaluation may break down first. Mobile usability or missing trust information can add friction. Cart and checkout problems compound the result.',
      },
      {
        title: 'Are your teams getting different answers about what is wrong?',
        description:
          'Specialists often diagnose the store through the lens of one discipline. Their recommendations may conflict or depend on technical work that no team currently owns.',
      },
      {
        title:
          'Are you considering a major investment without a clear diagnosis?',
        description:
          'Before investing in a redesign or migration, you need to understand what is wrong with your current store. An audit helps you decide whether you need a major change or a smaller fix before committing your budget.',
      },
    ],
    deliverablesHeading: 'What our ecommerce website audit includes',
    deliverablesIntro:
      'The audit combines representative pages with available performance data and operational context. The result is a cross-functional roadmap rather than separate lists from separate specialists.',
    deliverables: [
      {
        title: 'Customer journey and conversion review',
        description:
          'We inspect the customer journey from finding a product to reaching checkout.',
      },
      {
        title: 'Technical and platform review',
        description:
          'We assess whether the current technical foundation supports the business.',
      },
      {
        title: 'Search visibility and content review',
        description:
          'We examine whether important pages are technically accessible and easy to understand.',
      },
      {
        title: 'Analytics and measurement review',
        description:
          'We review whether your tracking records the information you need to evaluate performance.',
      },
      {
        title: 'Speed, accessibility, and quality review',
        description:
          'We identify speed and usability problems that make shopping harder.',
      },
      {
        title: 'Prioritized roadmap and review',
        description: 'We group findings by impact and urgency.',
      },
    ],
    platforms: [
      'Shopify and Shopify Plus',
      'BigCommerce',
      'WooCommerce',
      'GA4 and Tag Manager',
      'Google Search Console',
      'Semrush',
      'Klaviyo',
      'Google Ads and Merchant Center',
    ],
    credentials: [
      'A cross-functional team spanning ecommerce design, development, SEO, paid media, email, analytics, migration, and maintenance.',
      'Shopify Partner, BigCommerce Partner, Google Partner, Klaviyo Partner, and Semrush Agency Partner relationships represented on Ventura’s website.',
      'More than 25 years of ecommerce work and over 1,000 website launches.',
    ],
    processIntro:
      'We define the business concern and inspect representative evidence across the store. Then we separate material issues from noise and organize the result by ownership and sequence.',
    process: [
      {
        title: 'We learn about your goals and concerns',
        description:
          'We document the business concern and the history behind it. Recent changes may explain the current symptoms. Stakeholders and vendors show who owns each system. Analytics and marketing accounts provide performance evidence. Known constraints shape the review.',
      },
      {
        title: 'We review how your store works',
        description:
          'We inspect representative pages and purchasing paths on appropriate devices. We also review your tracking and connected tools to identify problems that are not obvious from looking at the pages.',
      },
      {
        title: 'We identify what needs attention first',
        description:
          'We organize the issues by customer and business impact. Urgency and effort help determine the order. Risk and dependencies may change that sequence. Affected templates reveal the size of the problem. Responsible teams are identified for each recommendation.',
      },
      {
        title: 'We walk you through our recommendations',
        description:
          'We explain the findings and answer questions about implementation. The roadmap explains whether the next step is development, SEO, marketing, or ongoing maintenance instead of sending the client in several directions at once.',
      },
    ],
    faqs: [
      {
        question:
          'What is the difference between the free call and the paid audit?',
        answer:
          'The free call is a short chat about your store and what you need help with. During the paid audit, our team checks your store and gives you a plan for what to fix first. The audit price does not include the work to make those fixes.',
      },
      {
        question: 'What is included in an ecommerce website audit?',
        answer:
          'The audit reviews the customer journey and the systems that support it. Depending on scope, it can address storefront usability and technical quality. Measurement and organic visibility may also be included. Performance and accessibility receive separate consideration. Retention marketing or paid-media readiness can provide additional context.',
      },
      {
        question: 'How is this different from an ecommerce SEO audit?',
        answer:
          'The website audit looks beyond SEO at how customers use your store, how your team manages it, and the technology supporting both. The SEO audit focuses on organic search performance, including crawlability, indexing, content quality, and internal links.',
      },
      {
        question: 'Will the audit tell us whether we need a redesign?',
        answer:
          'Yes. We explain whether focused fixes, a redesign, or a platform change would best address the problems we find.',
      },
      {
        question: 'Do you implement the audit recommendations?',
        answer:
          'Implementation can follow through a defined project, hourly block, or ongoing support engagement. The standalone audit does not automatically include every recommended change.',
      },
      {
        question: 'What access is needed for the audit?',
        answer:
          'Typical access begins with the ecommerce platform and available measurement tools. Depending on scope, we may also request Search Console. Advertising or email accounts can provide additional context. Product feeds and app settings may reveal technical dependencies. We request only the systems required by the agreed audit scope.',
      },
    ],
  },
]

export function getCommercialServicePage(slug) {
  return commercialServicePages.find((page) => page.slug === slug) || null
}
